import { render, staticRenderFns } from "./SizeSelector.vue?vue&type=template&id=2a875fa0&scoped=true&"
import script from "./SizeSelector.vue?vue&type=script&lang=js&"
export * from "./SizeSelector.vue?vue&type=script&lang=js&"
import style0 from "./SizeSelector.vue?vue&type=style&index=0&id=2a875fa0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a875fa0",
  null
  
)

export default component.exports